export default "__VITE_ASSET__38f59b87__"